import Pristine from 'pristinejs';

export default class LoginForm {

	constructor(el) {
		this.el = el;
		var loginForm = this.el.querySelector('[name="loginform"]');
		this.tabAjaxQuery = [];
		this.initFormValidation(loginForm);

		const lostPassword = this.el.querySelector('.lost-password');
		const password = this.el.querySelector('.login-password');
		password.appendChild(lostPassword);

		const btnPassword = loginForm.querySelector('.button-mdp');
		const inputPassword = loginForm.querySelector('[type="password"]');
		const iconBtn = btnPassword.querySelector('.eye');
		if (btnPassword) {
			btnPassword.addEventListener("click", () => {
				
				if (btnPassword.dataset.toggle == "0") {
					btnPassword.dataset.toggle = "1";

					inputPassword.type = 'text'
					iconBtn.classList.toggle('is-hidden');
				} else {
					btnPassword.dataset.toggle = "0";

					inputPassword.type = 'password'
					iconBtn.classList.toggle('is-hidden');
				}
			});
		}
	}

	initFormValidation(elm) {

		var form = elm;
		let defaultConfig = {
			classTo: 'js-Form-field',
			errorClass: 'has-danger',
			successClass: 'has-success',
			errorTextParent: 'js-Form-field',
			errorTextTag: 'span',
			errorTextClass: 'wpcf7-not-valid-tip'
		};
		var pristine = new Pristine(form, defaultConfig);

		Pristine.addMessages('fr', {
			required: "Ce champ est requis",
			email: "Adresse email invalide",
			number: "Merci de renseigner un nombre",
			integer: "Merci de renseigner un nombre entier",
			url: "Merci de renseigner une URL",
			tel: "Merci de renseigner un numéro de téléphone",
			maxlength: "La longeur du champ doit être inférieure à ${1}",
			minlength: "La longeur du champ doit être supérieure à ${1}",
			min: "La valeur minimale est de ${1}",
			max: "La valeur maximale est de ${1}",
			pattern: "Merci de respecter le format attendu",
			equals: "Les deux champs ne correspondent pas"
		});
		Pristine.setLocale('fr');

		var that = this;
		form.addEventListener('submit', function (e) {

			e.preventDefault();

			var formIsValid = pristine.validate();

			if (formIsValid) {
				that.initFormAjax(form);
			}

		});

	}

	initFormAjax(form) {

		var $ = jQuery;
		this.stopAjaxQuery(this.tabAjaxQuery);

		var formData = $(form).serialize();
		var $notifElm = $('.hwc-Login-notif');

		var ajaxCall = $.ajax({
			url: hwc_vars.ajax_url,
			type: 'POST',
			dataType: 'JSON',
			//data: 'action=hwc_ajax_login&' + formData,
			data: {
                action: "hwc_ajax_login",
                config: formData,
            },
			success: function (tab_result) {

				if (tab_result.message) {

					$notifElm.html(tab_result.message);

					if ($notifElm.length) {
						if ($notifElm.is(':hidden')) {
							$notifElm.slideDown();
						}
						$('html, body').animate({
							scrollTop: parseInt($notifElm.offset().top - $('.hwc-Header').outerHeight() - 20)
						}, 1000);
					}

				}


				if (!tab_result.error && tab_result.redirect) {

					window.location.href = tab_result.redirect;

				}

			},
			error: function (errorThrown) {
			}
		});

		this.tabAjaxQuery.push(ajaxCall);

	}

	stopAjaxQuery(tQuery) {

		if (typeof (tQuery) == 'undefined') {
			tQuery = [];
		}

		for (var i = 0; i < tQuery.length; i++) {
			tQuery[i].abort();
		}

		tQuery.length = 0;

	}

}